import { isUpperEnvironment } from '@fluentsms/utils';

/**
 * Apollo Client decides whether it is running in "dev mode" by reading
 * `globalThis.__DEV__ !== false`, and every one of its console diagnostics is gated on
 * that flag, e.g. in `cache/inmemory/writeToStore.js`:
 *
 *     globalThis.__DEV__ !== false && invariant.error(13, resultKeyNameFromField(field), result);
 *
 * Our rsbuild bundle never defines `__DEV__` (see apps/fluentsms/rsbuild.config.ts
 * `source.define`), so the value is `undefined` in every build and Apollo treats eval
 * and prod as dev. That leaks console noise to end users and FullStory recordings
 *
 * This is gated at runtime rather than through an rsbuild `define` because eval, prod
 * and the deployed dev environment are all `NODE_ENV=production` builds — the
 * environment is resolved from the hostname — so a build-time define would also
 * silence the dev environment, where we want this noise to stay visible as tech debt.
 */
export const configureApolloLogging = (): void => {
  if (!isUpperEnvironment()) return;

  if (typeof window !== 'undefined') {
    window.__DEV__ = false;
  }
};
